import type { QueryClient } from '@tanstack/react-query';
import {
  createRootRouteWithContext,
  createRoute,
  lazyRouteComponent,
  Outlet,
} from '@tanstack/react-router';
import { SessionGate } from './session-gate';

/**
 * Route skeleton shared by every interface. Interfaces attach their own subtree under
 * `authedRoute` (see `src/interfaces/<name>/routes.tsx`); every page component is lazy so
 * each interface is its own chunk.
 */
export const rootRoute = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Outlet,
});

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  validateSearch: (search: Record<string, unknown>): { redirect?: string } =>
    typeof search.redirect === 'string' ? { redirect: search.redirect } : {},
  component: lazyRouteComponent(() => import('./login-page'), 'LoginPage'),
});

/** Pathless layout: everything below requires a signed-in session. */
export const authedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'authed',
  component: SessionGate,
});

export const launcherRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./launcher-page'), 'LauncherPage'),
});
